/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const consoleTag = "[custom.js]";
  console.log(consoleTag, "Loaded");
  
  // call method that handles pages
  handlePages();
  
  // call method to modify announcement bar text for international customers
  modifyAnnouncementText();
  
  // method that handles conditions on specific pages
  function handlePages() {
  	const pathArray = location.pathname.split("/"); // initialize and retrieve current URL pathname
    console.log(consoleTag, pathArray);
//     console.log(consoleTag, "Currently logged in:", customerEmail);
    if (pathArray.includes("account") && pathArray.length <= 2) { // Account Page
      // we are in the account page
      if (customerEmail && !localStorage.getItem('recentUser')) {
      	console.log(consoleTag, "Current user has not been saved");
        localStorage.setItem('recentUser', customerEmail);
      }
    } else if (pathArray.length == 2 && pathArray[0] == "" & pathArray[1] == "") { // Home Page
      // we are in the home page
      // check if the customer is on mobile
      const isMobile = navigator.userAgent.match(/(iphone|ipod|android|blackberry|windows ce|palm|symbian)/i);
      if (isMobile) {
        console.log(consoleTag, "mobile");
        const feelGoodImageContainer = document.querySelector('section[data-section-type="feel-good-crew"]').querySelector('.rewards-image-container');
      	// check if the user is logged in
        if (customerEmail) {
          feelGoodImageContainer.querySelector('img').src = "//cdn.shopify.com/s/files/1/0523/2735/0457/t/11/assets/mobile_page3.svg";
        } else if (!customerEmail && localStorage.getItem('recentUser')) {
          feelGoodImageContainer.querySelector('img').src = "//cdn.shopify.com/s/files/1/0523/2735/0457/t/11/assets/mobile_page2.svg";
        } else {
          feelGoodImageContainer.querySelector('img').src = "//cdn.shopify.com/s/files/1/0523/2735/0457/t/11/assets/mobile_page1.svg";
        }
      } else {
        // check that the user is not logged in and that they are registered
        if (!customerEmail && localStorage.getItem('recentUser')) {
          const feelGoodImageContainer = document.querySelector('section[data-section-type="feel-good-crew"]').querySelector('.rewards-image-container');
          feelGoodImageContainer.href = "/account/login";
          feelGoodImageContainer.querySelector('img').src = "//cdn.shopify.com/s/files/1/0523/2735/0457/t/11/assets/home_page2.svg";
        }
      }
    } else if (pathArray.includes("account") && pathArray.includes("register")) { // Register Page
//       let selectYear = document.querySelector(".birthday-year");
      let selectMonth = document.querySelector(".birthday-month");
      let selectDay = document.querySelector(".birthday-day");
      // add event listeners to selects
//       selectYear.addEventListener("change", function() {
//       	updateNumberOfDays();
//         let hiddenInput = document.querySelector("#birthday_input");
//         hiddenInput.value = selectMonth.value + "-" + selectDay.value + "-" + selectYear.value;
//       });
      selectMonth.addEventListener("change", function() {
      	updateNumberOfDays();
        let hiddenInput = document.querySelector("#birthday_input");
        hiddenInput.value = selectMonth.value + "-" + selectDay.value;
      });
      selectDay.addEventListener("change", function() {
        let hiddenInput = document.querySelector("#birthday_input");
        hiddenInput.value = selectMonth.value + "-" + selectDay.value;
      });
    } else if (pathArray.includes("cart")) { // Cart Page
//       console.log(consoleTag, "we are in cart page");
      document.addEventListener("update-cart-finished", function(e) {
//         console.log("Cart finished updating?", window.cart.subtotal);
        document.querySelector(".cart__widget .cart__widget-points").innerText = "You will earn " + Math.round(window.cart.subtotal / 100) + " points!";
      });
    }
  }
  
  // helper method that updates the number of days for the birthday inputs
  function updateNumberOfDays() {
//   	let selectYear = document.querySelector(".birthday-year");
    let selectMonth = document.querySelector(".birthday-month");
    let selectDay = document.querySelector(".birthday-day");
    let year = 2016;
    let month = parseInt(selectMonth.value || 1);
    const dayItems = document.querySelectorAll(".birthday-day option:not(:disabled)");
    dayItems.forEach(function(item) {
      item.style.display = "none";
    });
    let days = new Date(year, month, 0).getDate();
    for (let d = 1; d <= days; d++) {
      selectDay.querySelector('option[value="' + d + '"]').style.display = "block";
    }
  }
  
  // function to modify announcement bar text for international customers
  function modifyAnnouncementText() {
    const section = "[Announcement]";
  	const minFreeShipping = 80;
    
     // retrieve ip information
    fetch('https://www.cloudflare.com/cdn-cgi/trace').then(function(data) {
      return data.text();
    }).then(function(data) {
      const formattedData = data.split("\n");

      const locationElement = formattedData.find(e => e.includes("loc="));

      const location = locationElement.split("=");

      // check if location is US
      if (location[1] && location[1] == "US") {
        // retrieve continental price
//         console.log(section, "User is in the U.S.");
      } else {
//         console.log(section, "User is international");
        document.querySelectorAll(".announcement__bar .cart__message-default").forEach(function(element) {
          element.innerText = "FREE International Shipping On Orders $80 USD+";
        });
        // get the current cart
//         fetch("/cart.js")
//         .then(response => response.json())
//         .then(json => {
//           console.log(json);
//           const subtotal = json.items_subtotal_price / 100;
//           const difference = minFreeShipping - subtotal;
//           console.log(section, "current subtotal", subtotal);
// // 			document.querySelectorAll(".announcement__bar .cart__message-default").forEach(function(element) {
// //               element.text = "Free 
// //             });
//         });
     
      }
    }).catch(function(msg) {
      console.error("Could not get the location", msg);
    });
  }
})();
